import React from 'react'
import { DataTable } from '../../components'
import { SortOrder } from '../../components/DataTable'
import { Trace } from '../../types/DataTypes'

interface Props {
  traces: Trace[]
}

export const AuthenticCheckResults: React.FunctionComponent<Props> = ({ traces }) => {
  const hasShipTo = !!traces.filter((trace: Trace) => trace.ShipTo).length

  return (
    <div className="row animated fadeIn">
      <div className="col-md-12">
        <DataTable
          heading={`Serial Number: ${traces[0].serialNo}`}
          columns={[
            { title: 'Trace Time' },
            { title: 'Scanning Type' },
            { title: 'Order Number' },
            { title: 'Scanning Location' },
            { title: 'Scanned By' },
            { title: 'Article Number' },
            ...(hasShipTo ? [{ title: 'Received By' }] : []),
          ]}
          data={traces.map((trace: Trace) => [
            trace.id,
            trace.TraceTime,
            trace.TraceEvent,
            trace.OrderNo,
            trace.UserLocation,
            trace['User Name'],
            trace.ProductId,
            ...(hasShipTo ? [typeof trace.ShipTo === 'object' ? trace.ShipTo.Name : trace.ShipTo || ''] : []),
          ])}
          defaultSort={{ sortColumnIndex: 1, sortOrder: SortOrder.DESC }}
        />
      </div>
    </div>
  )
}
